import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const progressSizes = ["medium", "small", "mini"];

export const progressProps = buildProps({
  height: {
    type: Number,
  },
  size: {
    type: String,
    values: progressSizes,
    default: "medium",
  },
} as const);

export type ProgressProps = ExtractPropTypes<typeof progressProps>;
